enum RiskLevel {
  Low = 'low',
  Medium = 'moderate',
  High = 'high',
}

enum BloodPressureRiskLevel {
  Hypotension = 'Hypotension',
  Normal = 'Normal',
  Elevated = 'Elevated',
  Hypertension1 = 'Hypertension1',
  Hypertension2 = 'Hypertension2',
  HypertensionCrisis = 'HypertensionCrisis',
}

enum ArterialStiffnessRiskLevel {
  Low = 'low',
  High = 'high',
}

enum BmiRiskLevel {
  High1 = 'high1',
  Low = 'low',
  Medium = 'moderate',
  High2 = 'high2',
}

enum BodyFatRiskLevel {
  Medium1 = 'moderate1',
  Low = 'low',
  Medium2 = 'moderate2',
  High = 'high',
}

export {
  ArterialStiffnessRiskLevel,
  BmiRiskLevel,
  BodyFatRiskLevel,
  RiskLevel,
  BloodPressureRiskLevel,
};
